import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { artistsAPI, releasesAPI } from '../services/api';
import '../styles/landing.css';

function ArtistDetail() {
  const { id } = useParams();
  const [artist, setArtist] = useState(null);
  const [releases, setReleases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadArtist();
  }, [id]);

  const loadArtist = async () => {
    try {
      const response = await artistsAPI.getById(id);
      const artistData = response.data;
      setArtist(artistData);
      // Load releases for this artist after artist is loaded
      if (artistData) {
        loadArtistReleases(artistData.name);
      }
    } catch (error) {
      console.error('Error loading artist:', error);
      setError('Artist not found');
    } finally {
      setLoading(false);
    }
  };

  const loadArtistReleases = async (artistName) => {
    try {
      const response = await releasesAPI.getAll();
      const allReleases = response?.data || [];
      // Filter releases by artist name and reverse to show newest first
      const artistReleases = Array.isArray(allReleases) 
        ? allReleases.filter(r => r.artist === artistName)
        : [];
      setReleases([...artistReleases].reverse());
    } catch (error) {
      console.error('Error loading releases:', error);
      setReleases([]);
    }
  };

  if (loading) {
    return (
      <div className="landing-page">
        <div className="container" style={{ paddingTop: '100px', minHeight: '80vh' }}>
          <p style={{ color: '#a0a0a0', textAlign: 'center' }}>Loading artist...</p>
        </div>
      </div>
    );
  }

  if (error || !artist) {
    return (
      <div className="landing-page">
        <div className="container" style={{ paddingTop: '100px', minHeight: '80vh', textAlign: 'center' }}>
          <h1 className="section-title" style={{ marginBottom: '20px' }}>Artist Not Found</h1>
          <p style={{ color: '#a0a0a0', marginBottom: '30px' }}>{error || 'The artist you are looking for does not exist.'}</p>
          <Link to="/artists" style={{ color: '#228b22', textDecoration: 'none', fontSize: '1.1rem' }}>
            ← Back to All Artists
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="landing-page">
      <div className="container" style={{ paddingTop: '100px', paddingBottom: '80px', maxWidth: '900px' }}>
        <div style={{ marginBottom: '40px' }}>
          <Link to="/artists" style={{ color: '#228b22', textDecoration: 'none', fontSize: '1rem' }}>
            ← Back to All Artists
          </Link>
        </div>
        
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: '1fr 2fr', 
          gap: '40px',
          marginBottom: '60px',
          alignItems: 'start'
        }}>
          <div>
            <div 
              className="artist-image-placeholder"
              style={artist.image ? {
                backgroundImage: `url(${artist.image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                width: '100%',
                aspectRatio: '1',
                borderRadius: '8px'
              } : {
                width: '100%',
                aspectRatio: '1',
                borderRadius: '8px'
              }}
            ></div>
          </div>
          
          <div>
            <h1 style={{ 
              fontSize: '3rem', 
              marginBottom: '20px',
              color: '#228b22',
              fontFamily: 'Bungee, cursive'
            }}>
              {artist.name}
            </h1>
            {artist.createdAt && (
              <p style={{ 
                color: '#666', 
                fontSize: '0.9rem',
                fontStyle: 'italic',
                marginBottom: '30px'
              }}>
                Added: {new Date(artist.createdAt).toLocaleDateString('en-US', { 
                  year: 'numeric', 
                  month: 'long', 
                  day: 'numeric' 
                })}
              </p>
            )}
          </div>
        </div>

        {releases.length > 0 && (
          <div style={{ marginTop: '60px' }}>
            <h2 className="section-title" style={{ marginBottom: '30px', fontSize: '2rem' }}>
              RELEASES
            </h2>
            <div className="releases-grid" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '30px' }}>
              {releases.map((release) => (
                <Link 
                  key={release.id} 
                  to={`/releases/${release.id}`}
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  <div className="release-card" style={{ cursor: 'pointer', transition: 'transform 0.3s', height: '100%' }}>
                    <div 
                      className="release-image-placeholder"
                      style={release.image ? {
                        backgroundImage: `url(${release.image})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        minHeight: '250px'
                      } : { minHeight: '250px' }}
                    ></div>
                    <h3 className="release-artist">{release.artist}</h3>
                    <p className="release-title">{release.title}</p>
                    <span className="read-more">view details →</span>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        )}

        <div style={{ textAlign: 'center', marginTop: '60px' }}>
          <Link to="/" style={{ color: '#228b22', textDecoration: 'none', fontSize: '1.1rem' }}>
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ArtistDetail;

